import React from 'react';
import { Download, Filter, Search, ChevronDown, FileText } from 'lucide-react';
// Mock data based on screenshot
const WORKERS = [{
  id: 1,
  name: 'A.B. Olevic',
  phone: '+16466090377',
  contractor: 'Broadway Construction Group',
  prof: 'General Contractor',
  sticker: '-',
  site: 'Court Square LIC',
  role: 'Superintendent',
  image: 'https://i.pravatar.cc/150?u=1'
}, {
  id: 2,
  name: 'Diego Atariguana',
  phone: '+19293331080',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=2'
}, {
  id: 3,
  name: 'Pascual Rosas',
  phone: '+13473256208',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=3'
}, {
  id: 4,
  name: 'Asllan Gjokola',
  phone: '+19293679713',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=4'
}, {
  id: 5,
  name: 'Jorge Andreaggi',
  phone: '+19739531384',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '061',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=5'
}, {
  id: 6,
  name: 'Byron Taylor',
  phone: '+15163517451',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '144',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=6'
}, {
  id: 7,
  name: 'Jesse Gopeesingh',
  phone: '+13474999543',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '467',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=7'
}, {
  id: 8,
  name: 'Victor Penaranda',
  phone: '+19172882768',
  contractor: '(BIG APPLE) Big Apple Testing',
  prof: 'VENDOR',
  sticker: '601',
  site: '99 Claremont Ave',
  role: '',
  image: 'https://i.pravatar.cc/150?u=8'
}, {
  id: 9,
  name: 'Alvaro Reyas',
  phone: '+13478587250',
  contractor: '(CHARNEY CC) Charney Companies LLC',
  prof: 'VENDOR',
  sticker: '465',
  site: '99 Claremont Ave',
  role: '',
  image: 'https://i.pravatar.cc/150?u=9'
}, {
  id: 10,
  name: 'MARIA CLAUDINA YUCAILLA',
  phone: '+19296712337',
  contractor: '(Clear Path) Clear Path Contracting LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=10'
}];
export function WorkersTable() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-4043" data-mp="23c59yqqh380p">
      {/* Toolbar */}
      <div className="p-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-4044" data-mp="23dztq1q0cu37">
        <div className="text-lg font-medium text-gray-900" data-id="element-4045" data-mp="3j3qzoygq9r0m">4681 results</div>

        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-4046" data-mp="3j1myioa7r641">
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-4047" data-mp="1mg85fnuj41q">
            <button className="px-3 py-2 bg-gray-50 border-r border-gray-300 text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-100" data-id="element-4048" data-mp="3suc08rfyp5m6">
              All <ChevronDown size={14} data-id="element-4049" data-mp="355j7t4yjtfwb" />
            </button>
            <div className="relative" data-id="element-4050" data-mp="305wtstawbvmg">
              <input type="text" placeholder="Search" className="pl-3 pr-8 py-2 text-sm outline-none w-48" data-id="element-4051" data-mp="306zj4wsklq09" />
            </div>
          </div>

          <button className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-50" data-id="element-4052" data-mp="ubn5ibbkdnle">
            <Filter size={16} data-id="element-4053" data-mp="pbinuhyx6mtl" />
            Filters
          </button>

          <button className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-50" data-id="element-4054" data-mp="2v147blu6gswi">
            <Download size={16} data-id="element-4055" data-mp="300qlbxhtyd6d" />
            Download
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-4056" data-mp="3407rkt52zecl">
        <table className="w-full text-left border-collapse" data-id="element-4057" data-mp="390dooou4dt22">
          <thead data-id="element-4058" data-mp="391x0o38qthy1">
            <tr className="bg-gray-50 border-b border-gray-200 text-xs uppercase text-gray-500 font-semibold" data-id="element-4059" data-mp="38y9bthe8tjpn">
              <th className="p-4 w-10" data-id="element-4060" data-mp="3iyjmau8w8d14">
                <input type="checkbox" className="rounded border-gray-300" data-id="element-4061" data-mp="3ixi9olc8biha" />
              </th>
              <th className="p-4" data-id="element-4062" data-mp="3nqt8q0asuuyn">Image</th>
              <th className="p-4" data-id="element-4063" data-mp="3nrvzm884gxek">Name</th>
              <th className="p-4 text-center" data-id="element-4064" data-mp="3rrd8lbmrccoh">PDF</th>
              <th className="p-4" data-id="element-4065" data-mp="3rsxygny4n7g0">Phone</th>
              <th className="p-4" data-id="element-4066" data-mp="llk0gomp83s">Contractor</th>
              <th className="p-4" data-id="element-4067" data-mp="ipmgtgp0lfv">Contr. Prof.</th>
              <th className="p-4" data-id="element-4068" data-mp="5kyf1opnllhg">Sticker No.</th>
              <th className="p-4" data-id="element-4069" data-mp="5hkb4c1cd47w">Site Name</th>
              <th className="p-4" data-id="element-4070" data-mp="fovamuq0g242">Specializ / Certification</th>
            </tr>
          </thead>
          <tbody className="text-sm text-gray-700" data-id="element-4071" data-mp="aoh9zxqqnug2">
            {WORKERS.map(worker => <tr key={worker.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-4072" data-mp="5ow3915buhss">
                <td className="p-4" data-id="element-4073" data-mp="1qf5h87sqjo1">
                  <input type="checkbox" className="rounded border-gray-300" data-id="element-4074" data-mp="yeuyjea47b5w" />
                </td>
                <td className="p-4" data-id="element-4075" data-mp="teqgvkxh0ae3">
                  <img src={worker.image} alt={worker.name} className="w-10 h-10 rounded object-cover border border-gray-200" data-id="element-4076" data-mp="tfryk88zrv4s" />
                </td>
                <td className="p-4 font-medium text-gray-900" data-id="element-4077" data-mp="kl3v8nmz8nim">{worker.name}</td>
                <td className="p-4 text-center" data-id="element-4078" data-mp="1h646vk85ftvw">
                  <button className="text-gray-400 hover:text-gray-600" data-id="element-4079" data-mp="1cdksil1n0uq1">
                    <Download size={18} data-id="element-4080" data-mp="36lyd928bl71o" />
                  </button>
                </td>
                <td className="p-4 text-gray-500" data-id="element-4081" data-mp="36oasv8qlv5bk">{worker.phone}</td>
                <td className="p-4" data-id="element-4082" data-mp="3bki1586h4swo">{worker.contractor}</td>
                <td className="p-4" data-id="element-4083" data-mp="2wwol5mdh7odk">{worker.prof}</td>
                <td className="p-4" data-id="element-4084" data-mp="2wvvd8i2s6stu">{worker.sticker}</td>
                <td className="p-4" data-id="element-4085" data-mp="31ugbibyh32fn">{worker.site}</td>
                <td className="p-4 text-gray-500" data-id="element-4086" data-mp="31svhqojzfniu">{worker.role}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination (Visual only) */}
      <div className="p-4 border-t border-gray-200 flex justify-between items-center text-sm text-gray-500" data-id="element-4087" data-mp="2svuzkznialnu">
        <div data-id="element-4088" data-mp="2dzdpebr1zd2v">Showing 1-10 of 4681</div>
        <div className="flex gap-2" data-id="element-4089" data-mp="2ivubz1iltjdu">
          <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50" disabled data-id="element-4090" data-mp="2iwvxjzx8xo9t">
            Previous
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-4091" data-mp="h3pk1q13um34">
            Next
          </button>
        </div>
      </div>
    </div>;
}